import ProjectTeamManageModalModule from './manage-modal.module'

export default ProjectTeamManageModalModule
